import * as mdb from 'mdb-ui-kit'
import Logo from '../img/logo-clear-footer.png'

export default {
  mdb,
}

const logo = Logo
